<template>
  <div class="font-display text-[11px] font-semibold tracking-[0.16em] uppercase" :class="tone === 'ink' ? 'text-ink' : 'text-faint'">
    <slot />
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    /** `faint` for in-card group headings; `ink` for the sidebar section title. */
    tone?: 'faint' | 'ink'
  }>(),
  { tone: 'faint' },
)
</script>
